module.exports = __webpack_public_path__ + "img/feature-tile-icon-03.5ba38cd7.svg";